var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.parentClasses},[_c('div',{staticClass:"hex-wrap",class:_vm.borderColor,style:({ height: _vm.height, width: _vm.width })},[(_vm.border)?_c('div',{staticClass:"hex",style:({ height: _vm.height, width: _vm.width })},[_vm._t("default")],2):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }